<div class="ad">
  <!-- ── Breadcrumb (full width) ── -->
  <breadcrumb [breadcrumbs]="breadcrumbLinks" />

  @if (assetResource?.hasValue()) {
    @let asset = assetResource.value();
    <asset-detail-header
      [asset]="asset"
      [snackbarVisible]="snackbarVisible()"
      [requestAccessModalOpen]="requestAccessModalOpen()"
      [requestReason]="requestReason()"
    />

    <!-- ── Tabs (standard layout only) ── -->
    <div class="ad__tabs" [class.ad__tabs--stuck]="tabsStuck()">
      <button
        class="ad__tab"
        [class.ad__tab--active]="activeTab() === 'overview'"
        (click)="setTab('overview')"
      >
        Overview
      </button>
      <button
        class="ad__tab"
        [class.ad__tab--active]="activeTab() === 'source'"
        (click)="setTab('source')"
      >
        Source &amp; Governance
      </button>
      <button
        class="ad__tab"
        [class.ad__tab--active]="activeTab() === 'technical'"
        (click)="setTab('technical')"
      >
        Technical
      </button>
      <button class="ad__tab" disabled>
        Versions <span class="ad__tab-coming-soon">Coming soon</span>
      </button>
      <button class="ad__tab" disabled>
        Preview <span class="ad__tab-coming-soon">Coming soon</span>
      </button>
      <button class="ad__tab" disabled>
        Use Case <span class="ad__tab-coming-soon">Coming soon</span>
      </button>
      <div class="ad__tabs-rule"></div>
    </div>

    <!-- ── Standard tabbed layout ── -->
    <div class="ad__body">
      <asset-detail-content [asset]="asset" [activeTab]="activeTab()" />
      <asset-detail-sidebar [asset]="asset" />
    </div>

    <!-- NOTE: to add once related assets returned by BE -->
    <!-- ── Related assets (always at the same vertical position) ── -->
    <!-- @if (asset.relatedAssets?.length) { -->
    <!--   <div class="ad__related"> -->
    <!--     <h3 class="ad__related-title">Related Assets</h3> -->
    <!--     <div class="ad__related-grid"> -->
    <!--       @for (r of asset.relatedAssets!; track r.title) { -->
    <!--         <asset-card -->
    <!--           [id]="r.title" -->
    <!--           [title]="r.title" -->
    <!--           [description]="r.description" -->
    <!--           [viewCount]="r.users" -->
    <!--           [usesCount]="r.downloads" -->
    <!--           [restricted]="r.restricted ?? false" -->
    <!--           [rai]="r.rai ?? false" -->
    <!--         ></asset-card> -->
    <!--       } -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- } -->

    <!-- ── Snackbar ─────────────────────────────────────────────────────── -->
    @if (snackbarVisible()) {
      <div class="ad__snackbar" role="status" aria-live="polite">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
        Bookmarked
      </div>
    }

    <!-- ── Request Access Modal ───────────────────────────────────────────── -->
    @if (requestAccessModalOpen()) {
      <div
        class="ad__modal-overlay"
        (click)="closeRequestAccessModal()"
        role="dialog"
        aria-modal="true"
        aria-label="Request Access"
      >
        <div class="ad__modal-card ad__modal-card--access" (click)="$event.stopPropagation()">
          <button
            class="ad__modal-close"
            type="button"
            (click)="closeRequestAccessModal()"
            aria-label="Close"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          <h2 class="ad__modal-title">Request Access</h2>
          <p class="ad__modal-subtitle">
            Provide required details to access the asset "{{ asset.asset_name }}".
          </p>

          <p class="ad__ra-label">Requesting as</p>
          <div class="ad__ra-user">
            <span class="ad__ra-avatar">JD</span>
            <div class="ad__ra-user-info">
              <span class="ad__ra-name">Jane Doe</span>
              <span class="ad__ra-meta"
                >janedoe&#64;adb.org · Sustainable Development &amp; Climate Change</span
              >
            </div>
          </div>

          <div class="ad__modal-comment-wrap">
            <label class="ad__modal-label" for="ra-reason">Reason for Access Request</label>
            <textarea
              id="ra-reason"
              class="ad__modal-textarea"
              maxlength="255"
              rows="5"
              placeholder="Enter a justification for how you plan to use this asset"
              (input)="requestReason.set($any($event.target).value)"
              >{{ requestReason() }}</textarea>
          </div>

          <p class="ad__ra-policy">
            By requesting access, you agree to ADB's
            <a href="#" class="ad__ra-link">data usage</a> and
            <a href="#" class="ad__ra-link">confidentiality policies</a>.
          </p>

          <div class="ad__ra-actions">
            <button class="ad__ra-cancel" type="button" (click)="closeRequestAccessModal()">
              Cancel
            </button>
            <button class="ad__modal-submit" type="button" (click)="submitAccessRequest()">
              Submit Request
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ── Request submitted snackbar ─────────────────────────────────────── -->
    @if (requestSubmitted()) {
      <div class="ad__snackbar ad__snackbar--wide" role="status" aria-live="polite">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
        Access request submitted &bull; Ref: DN-REQ-84502 &bull; Expected review: 14–48 hours
      </div>
    }
  } @else {
    <div class="loader-container"><loader size="64px" /></div>
  }
</div>
